import(/* webpackMode: "eager" */ "/vercel/path0/app/resources/documentation/platform-guide/page.tsx");
